import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { AlertsPage as PartLibraryAlertsPage } from '@/areas/risk-management/Alerts/AlertsPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/alerts')({
    staticData: { access: { permissions: ['view:alert'] }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PartLibraryAlertsPage />;
}
